import { render } from "./edit-summary.vue?vue&type=template&id=227a4092"
import script from "./edit-summary.vue?vue&type=script&lang=js"
export * from "./edit-summary.vue?vue&type=script&lang=js"

import "./edit-summary.vue?vue&type=style&index=0&id=227a4092&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__